import { render, staticRenderFns } from "./modal-container.vue?vue&type=template&id=544ceb39&"
import script from "./modal-container.component.ts?vue&type=script&lang=ts&"
export * from "./modal-container.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports